import { Component, OnDestroy, OnInit } from '@angular/core'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { environment } from '../../../../environments/environment'
import { tap } from 'rxjs/operators'
import { Subscription } from 'rxjs'
import { EventService, User } from '@spartacus/core'
import { AuthenticationEvent } from '../../analytics/events/authentication.event'

@Component({
  selector: 'mb-myaccount',
  templateUrl: './mb-myaccount.component.html',
  styleUrls: ['./mb-myaccount.component.scss'],
})
export class MbMyaccountComponent implements OnInit, OnDestroy {

  environment = environment
  muRegistrationUrl = this.environment.myAccount.hostedPages.baseUrl.concat(
                          environment.myAccount.hostedPages.registerPage,
                          environment.myAccount.hostedPages.registerMuParams
                      )
  user$ = this.userService.get()
  userSub = new Subscription()

  constructor (private userService: UserAccountFacade, private eventService: EventService) {}

  ngOnInit () {
    this.userSub = this.user$.pipe(tap((user) => {
      if(user) {
        const cdcUser = user as User
        const uid = cdcUser.cdcUID
        if(uid) {
          localStorage.setItem('cdcUID', uid)
          const authEvent = new AuthenticationEvent(uid)
          this.eventService.dispatch(authEvent)
        }
      }
    })).subscribe()
  }

  ngOnDestroy () {
    if(this.userSub) {
      this.userSub.unsubscribe()
    }
  }
}
